import {Link} from "react-router-dom";

function ServiceTabSection() {
    return (
        <section id="tabs-1" className="wide-100 tabs-section division">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">


                        <div id="tabs-nav" className="list-group text-center">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">

                                <li className="nav-item icon-xs">
                                    <a className="nav-link active p-3" id="tab1-list" data-toggle="pill" href="#tab-1"
                                       role="tab" aria-controls="tab-1" aria-selected="true">
                                        <span className="flaticon-083-stethoscope"></span> Internal Medicine
                                    </a>
                                </li>

                                <li className="nav-item icon-xs">
                                    <a className="nav-link p-3" id="tab2-list" data-toggle="pill" href="#tab-2" role="tab"
                                       aria-controls="tab-2" aria-selected="false">
                                        <span className="flaticon-005-blood-donation-3"></span> Obstetric and
                                        Gyneacology
                                    </a>
                                </li>

                                <li className="nav-item icon-xs">
                                    <a className="nav-link p-3" id="tab3-list" data-toggle="pill" href="#tab-3" role="tab"
                                       aria-controls="tab-3" aria-selected="false">
                                        <span className="flaticon-031-scanner"></span> General Surgery
                                    </a>
                                </li>

                                <li className="nav-item icon-xs">
                                    <a className="nav-link p-3" id="tab4-list" data-toggle="pill" href="#tab-4" role="tab"
                                       aria-controls="tab-4" aria-selected="false">
                                        <span className="flaticon-109-injection"></span> Dental & Maxillofacial Surgery
                                    </a>
                                </li>

                            </ul>

                        </div>


                        <div className="tab-content text-left" id="pills-tabContent">

                            <div className="tab-pane fade show active" id="tab-1" role="tabpanel"
                                 aria-labelledby="tab1-list">
                                <div className="row d-flex align-items-center">

                                    <div className="col-lg-6">
                                        <div className="tab-img">
                                            <img className="img-fluid"
                                                 src={require('../../../images/internal_down.jpg')}
                                                 alt="tab-image"/>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="txt-block pc-30">

                                            <h3 className="h3-md steelblue-color">Internal Medicine</h3>

                                            <p className="mb-30 text-justify">At <b>Garkuwa Specialist Hospital</b>, our Internal Medicine department is dedicated to providing comprehensive, high-quality care for adults. Internal medicine focuses on the prevention, diagnosis, and treatment of a wide variety of medical conditions affecting the internal organs, such as the heart, lungs, liver, kidneys, and digestive system.
                                            </p>


                                            <Link to="/service/internal-medicine" className="btn btn-blue blue-hover mt-30">View
                                                More Details</Link>

                                        </div>
                                    </div>


                                </div>
                            </div>


                            <div className="tab-pane fade" id="tab-2" role="tabpanel" aria-labelledby="tab2-list">
                                <div className="row d-flex align-items-center">


                                    <div className="col-lg-6">
                                        <div className="tab-imgs">
                                            <img className="img-fluid" src={require('../../../images/antenatal.jpg')}
                                                 alt="tab-image"/>
                                        </div>
                                    </div>


                                    <div className="col-lg-6">
                                        <div className="txt-block pc-30">

                                            <h3 className="h3-md steelblue-color">Obstetric and Gyneacology</h3>

                                            <p className="mb-30 text-justify">Our Obstetrics & Gynecology (OB/GYN)
                                                Department is dedicated to providing comprehensive, compassionate, and
                                                expert care for women at every stage of life. From prenatal care to
                                                advanced gynecological treatments, we prioritize women’s health and
                                                wellness.
                                            </p>

                                            <Link to="/service/obstetric-gynecology" className="btn btn-blue blue-hover mt-30">View
                                                More Details</Link>

                                        </div>
                                    </div>


                                </div>
                            </div>


                            <div className="tab-pane fade" id="tab-3" role="tabpanel" aria-labelledby="tab3-list">
                                <div className="row d-flex align-items-center">


                                    <div className="col-lg-6">
                                        <div className="tab-img">
                                            <img className="img-fluid" src={require('../../../images/surgery.jpg')} alt="tab-image"/>
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="txt-block pc-30">

                                            <h3 className="h3-md steelblue-color">General Surgery</h3>

                                            <p className="mb-30 text-justify">At Garkuwa Specialist Hospital, our
                                                General Surgery Department provides advanced surgical solutions for a
                                                wide range of conditions. Our expert surgeons use modern techniques and
                                                state-of-the-art equipment to ensure successful outcomes and fast
                                                recovery.
                                            </p>


                                            <Link to="/service/general-surgery" className="btn btn-blue blue-hover mt-30">View
                                                More Details</Link>

                                        </div>
                                    </div>


                                </div>
                            </div>


                            <div className="tab-pane fade" id="tab-4" role="tabpanel" aria-labelledby="tab4-list">
                                <div className="row d-flex align-items-center">


                                    <div className="col-lg-6">
                                        <div className="tab-img">
                                            <img className="img-fluid" src={require('../../../images/dental.jpg')} alt="tab-image"/>
                                        </div>
                                    </div>


                                    <div className="col-lg-6">
                                        <div className="txt-block pc-30">

                                            <h3 className="h3-md steelblue-color">Dental & Maxillofacial Surgery</h3>

                                            <p className="mb-30 text-justify">
                                                Our Dental & Maxillofacial Surgery Department provides specialized
                                                surgical care for the mouth, jaw, and facial structures. With
                                                cutting-edge technology and a team of experienced specialists, we offer
                                                safe and effective treatments for dental and facial conditions.
                                            </p>
                                            <Link to="/service/dental-maxillofacial-surgery" className="btn btn-blue blue-hover mt-30">View More
                                                Details</Link>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>


                    </div>
                </div>
            </div>
        </section>
    )
}

export default ServiceTabSection;